import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

// React Router keeps the scroll position when the URL changes, which is why
// clicking a product from halfway down the grid drops you halfway down the
// product page. Browsers do this for back/forward navigation on purpose; for a
// fresh navigation it just looks broken.
//
// Mount once inside <BrowserRouter>. Resets on a genuine path change, so the
// browser still restores position correctly on back and forward.
//
// A link to a section of another page (/architects-interior-designers#ceiling-tool)
// opens at that section instead: the page renders, then it scrolls there.

export default function ScrollToTop() {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    if (typeof window === 'undefined') return undefined;
    if ('scrollRestoration' in window.history) {
      window.history.scrollRestoration = 'manual';
    }
    window.scrollTo({ top: 0, left: 0, behavior: 'instant' });
    if (!hash) return undefined;
    const id = decodeURIComponent(hash.slice(1));
    let tries = 0;
    let timer = null;
    const go = () => {
      const el = document.getElementById(id);
      if (el) { el.scrollIntoView({ block: 'start' }); return; }
      tries += 1;
      if (tries < 20) timer = setTimeout(go, 50);
    };
    timer = setTimeout(go, 0);
    return () => clearTimeout(timer);
    // Only on a path change: a hash change on the same page is the browser's own jump.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pathname]);

  return null;
}
